import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/educationSafety/img/1.avif';
import image2 from '@src/assets/images/solution/educationSafety/img/2.avif';
import image3 from '@src/assets/images/solution/educationSafety/img/3.avif';
import image4 from '@src/assets/images/solution/educationSafety/img/4.avif';

import customer1 from '@src/assets/images/solution/publicFire/img/customer1.avif';
import function1 from '@src/assets/images/solution/educationSafety/img/function1.avif';
import function2 from '@src/assets/images/solution/educationSafety/img/function2.avif';
import function3 from '@src/assets/images/solution/educationSafety/img/function3.avif';
import function4 from '@src/assets/images/solution/educationSafety/img/function4.avif';
import { educationSafety1, recommendationEdge, recommendationSwitch } from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '校园解决方案',

  banner: {
    title: '通过 AI 视频分析智能守护校园安全',
    desc: 'AI 利用现有 CCTV 识别校园内异常行为与危险情况，并安全保护个人隐私。',
  },

  recommend: {
    title: '',
    desc: 'ORBRO OS 是一款强大的平台，支持实时定位追踪与智能监控。<br/>融合 BLE、UWB 和基于 AI 的视频分析技术，专为提升现场的安全性、效率与可扩展性而设计。',
    labels: {
      desktop: [
        { img: educationSafety1, data: recommendation.ipCamera },
        { img: recommendationEdge, data: recommendation.edgeRtls },
        { img: recommendationSwitch, data: recommendation.switch },
      ],
      mobile: [{ data: recommendation.ipCamera }, { data: recommendation.edgeAi }, { data: recommendation.switch }],
    },
  },

  summary: {
    title: '实时发现危险并立即应对',
    desc: '通过 AI 姿态识别技术，实时检测学生之间的打架、跌倒、昏迷、突发行为等危险事件，适用于走廊、楼梯、教室、实验室等多种空间，帮助快速响应、及时预防事故。',
    function: {
      card: [
        {
          image: function1,
          title: '自动检测打架行为',
          desc: '通过姿态动作识别两人间的肢体冲突、挥拳、推搡等暴力行为，一旦发现征兆，立即通知管理人员，提前预防校园暴力事件。',
        },
        {
          image: function2,
          title: '检测走廊/楼梯跌倒事故并报警',
          desc: '识别楼梯或走廊中学生摔倒的动作，检测后立即发送警报，确保第一时间进行紧急处理。',
        },
        {
          image: function3,
          title: '检测长时间躺地/昏迷状态',
          desc: '检测学生摔倒后长时间无动作或异常姿势，判断为昏迷或癫痫等紧急情况并发出警告。',
        },
        {
          image: function4,
          title: '自动识别异常行为（奔跑、突发动作）',
          desc: '识别走廊或楼梯中突然奔跑或无规律的异常行为，及时预警，防止发生碰撞事故。',
        },
      ],
    },
  },

  numOfCard: {
    title: '通过 AI 技术最大化校园安全管理效率',
    desc: '利用实时检测功能，快速高效应对校园内异常行为与危险情况。',
    card: [
      {
        tag: '98%',
        title: '异常行为检测准确率',
        desc: '基于 AI 的精确分析，快速识别并响应各种校园异常行为和紧急状况。',
      },
      {
        tag: '95%',
        title: '运维人力减少效果',
        desc: '自动化系统可大幅降低对人工运维的依赖，提高整体运营效率。',
      },
      {
        tag: '100%',
        title: '隐私保护合规率',
        desc: '系统不进行连续录像，仅在事件发生时短暂录制片段，严格遵守隐私保护规范。',
      },
    ],
  },

  func: [
    {
      theme: '通过先进 AI 功能精准识别并应对校园风险',
      title: '自动记录各类事件响应信息',
      desc: 'AI 姿态识别技术可精准分析强烈动作、异常或攻击行为，自动检测危险并实现快速响应。',
      sub1: '高精度识别',
      icon1: IconRulerGray,
      sub2: '实时状态感知',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '分级风险即时告警（5 级）',
      desc: 'AI 分析结果按 5 个等级划分风险并立即通知相关负责人，根据危险等级实施有效应对。',
      sub2: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub1: '快速数据联动',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '支持本地部署的独立运行',
      desc: '可在校园内部署私有服务器，减少对外部服务依赖，实现数据自主管理与快速响应。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '高精度识别',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '保护隐私的事件触发型视频记录',
      desc: '仅在识别到危险事件时才进行短时录像，不持续保存视频，最大程度保护学生隐私并减轻 CCTV 管理负担。',
      sub1: '灵活区域设置',
      icon1: IconZoneGray,
      sub2: '支持多区域设定',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  subfunc: {
    title: '功能总览',
    desc: '保障作业安全不仅提升效率，也减少事故损失。ORBRO 提供专为校园安全打造的功能体系，涵盖危险区域靠近、突发事故、设备引发的安全风险等多种场景。',
    data: [
      {
        icon: IconAnalytics,
        title: 'AI 自动检测危险行为',
        desc: '自动识别强动作、异常举动、攻击行为，实时感知潜在风险。',
      },
      {
        icon: IconChartBar,
        title: '五级风险预警系统',
        desc: '将风险划分为 5 个等级并即时发送清晰告警信息。',
      },
      {
        icon: IconSearch,
        title: '基于事件的视频保存',
        desc: '仅在发生异常事件时保存简短视频片段，强化隐私保护。',
      },
      {
        icon: IconLayers,
        title: '利用现有 CCTV 系统',
        desc: '无需新增设备，即可将现有监控系统接入 AI 分析平台。',
      },
      {
        icon: IconRoute,
        title: '支持特定区域部署',
        desc: '可按需部署于托管教室等特定场所，实现重点区域监控。',
      },
      {
        icon: IconLayers,
        title: '本地独立部署与运行',
        desc: '基于校园本地服务器构建系统，响应更快，自主管理更高效。',
      },
      {
        icon: IconChartBar,
        title: '最小化运营人力',
        desc: '通过自动化管理系统实现无人工值守高效运维。',
      },
      {
        icon: IconSearch,
        title: '加强隐私保护',
        desc: '不持续录像，仅在需要时记录，有效防止隐私泄露。',
      },
    ],
  },

  system: {
    title: '系统构成',
    img: rtlsSystem,
  },

  productTitle: '产品组成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
